var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilWrite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3934 18.8479L12.4441 19.5559L13.1508 14.6053L25.8788 1.87728C26.4414 1.31467 27.2044 0.998596 28.0001 0.998596C28.3941 0.998596 28.7842 1.07619 29.1482 1.22696C29.5121 1.37772 29.8429 1.5987 30.1214 1.87728C30.4 2.15586 30.621 2.48658 30.7718 2.85056C30.9225 3.21454 31.0001 3.60465 31.0001 3.99861C31.0001 4.39258 30.9225 4.78269 30.7718 5.14667C30.621 5.51065 30.4 5.84137 30.1214 6.11995L17.3934 18.8479Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4641 3.29211L28.7068 7.53478",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19V29C25 29.5304 24.7893 30.0391 24.4142 30.4142C24.0391 30.7893 23.5304 31 23 31H3C2.46957 31 1.96086 30.7893 1.58579 30.4142C1.21071 30.0391 1 29.5304 1 29V9C1 8.46957 1.21071 7.96086 1.58579 7.58579C1.96086 7.21071 2.46957 7 3 7H13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWrite);
export default __webpack_public_path__ + "static/media/PencilWrite.a60a7e1a4ba8f1672e74af6c8b675c00.svg";
export { ForwardRef as ReactComponent };